import { createSelector } from '@ngrx/store';

import { RoleEnum } from '@core/enums/role.enum';
import { AppStoreState } from '@interfaces/app-store-state';
import { User } from '@models/user.model';

export const userSelector = (state: AppStoreState): User => state?.user;

export const userIsFormalistSelector = createSelector(userSelector, (user: User) =>
  user.roles.includes(RoleEnum.roleFormalist)
);

export const userIsNotarySelector = createSelector(userSelector, (user: User) =>
  user.roles.includes(RoleEnum.roleNotary)
);
